import React, { Fragment, useState } from 'react'
import pluralize from 'pluralize'
import { Divider } from 'antd'
import { AddNewItem } from 'components'
import CreateOrSelect from 'views/ScanSettings/NewScan/components/CreateSelect'
import { SaveItemButtonPrimary, StyledSelectedList } from 'views/ScanSettings/NewScan/style'
import SelectedList from 'views/ScanSettings/NewScan/components/SelectedList'
import { SUCCESS } from 'views/ScanSettings/NewScan/constants'

const { singular } = pluralize

const DynamicForm = ({
	children,
	form,
	dataType,
	dataTypeText,
	dataList,
	formFields,
	nameProp,
	onAddNewItem,
	primary,
	multiple = true,
	remoteValidation,
	setValidationError,
	resetFlowUploadFile,
	onEditItem,
	onDeleteItem
}) => {
	const [formVisible, setFormVisible] = useState(false)
	const [editFormItem, setEditFormItem] = useState(null)
	const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields, resetFields } = form

	getFieldDecorator(dataType, { initialValue: [] })

	const setSelected = newItem => {
		let selected = [newItem, ...selectedItems]
		setFieldsValue({ [dataType]: selected })
		setFormVisible(false)
	}

	const editItemClicked = editItem => {
		let index = dataList.findIndex((c) => c.id === editItem.id);
		let item = dataList[index];
		setEditFormItem(item)
		setFieldsValue({
			"cookie_name": item.name,
			"cookie_value": item.value,
			"cookie_domain": item.domain
		})
		setFormVisible(true)
	}

	
	const addSelected = item => {
		setSelected({
			id: item.key,
			name: item.label
		})
	}
	
	const removeSelected = item => {
		let filterByProp = item[nameProp] ? nameProp : 'id'
		let selected = selectedItems.filter(s => s[filterByProp] !== item[filterByProp])
		setFieldsValue({ [dataType]: selected })
		if (!formVisible && !selected.length && !dataList.length) setFormVisible(true)
	}
	
	const editSelected = () => {
			validateFields(formFields, async (errors, values) => {
				if (!errors) {
					setValidationError(null);
					let serverResponse = remoteValidation && await remoteValidation(values);
					if(!remoteValidation || serverResponse === SUCCESS || serverResponse.errors[0] == 'Cookie already exist'){
						let item = {}
						formFields.forEach(field => (item[field] = values[field]))
						item.id = editFormItem.id
						if (onEditItem) onEditItem(item)
						resetFields(formFields)
						let dataIndex = dataList.findIndex((x) => x.id === item.id);
						let selectedIndex = selectedItems.findIndex((x) => x.id === item.id);
						if (dataIndex !==-1 && selectedIndex !==-1) {
							dataList[dataIndex].name = item[nameProp];
							dataList[dataIndex].value = item.cookie_value;
							dataList[dataIndex].domain = item.cookie_domain;
							selectedItems[selectedIndex].name = item[nameProp];
						}		
						setFormVisible(false)
						resetFlowUploadFile && resetFlowUploadFile();
						removeSelected(item);
					}
					else if(serverResponse && !!serverResponse.errors.length){
						window.scrollTo(0, 0);
						setValidationError(serverResponse.errors);
					}
				}
				setEditFormItem(null);
			})
	}
	
	const addNewItem = () => {
		validateFields(formFields, async (errors, values) => {
			if (!errors) {
				setValidationError(null);
				let serverResponse = remoteValidation && await remoteValidation(values);
				if(!remoteValidation || serverResponse === SUCCESS){
					let item = {}
					formFields.forEach(field => (item[field] = values[field]))
					if (onAddNewItem) onAddNewItem(item)
					resetFields(formFields)
					setSelected(item)
					resetFlowUploadFile && resetFlowUploadFile();
				}
				else if(serverResponse && !!serverResponse.errors.length){
					window.scrollTo(0, 0);
					setValidationError(serverResponse.errors);
				}
			}
		})
	}

	let selectedItems = getFieldValue(dataType)
	let saveButtonText = `SAVE ${pluralize.singular(dataTypeText).toUpperCase()}`
	return (
		<Fragment>
			<CreateOrSelect
				list={dataList}
				selectedItems={selectedItems}
				dataTypeText={dataTypeText}
				onAddNewItem={() => setFormVisible(true)}
				onSelect={addSelected}
				allowMultiple={multiple}
			/>

			{!formVisible && selectedItems && selectedItems.length > 0 && (
				<StyledSelectedList>
					<SelectedList list={selectedItems} onDelete={removeSelected} onDeleteItem={onDeleteItem} onEditItem={onEditItem} editItemClicked={editItemClicked} nameProp={nameProp} type={dataTypeText} />
				</StyledSelectedList>
			)}

			{!formVisible && selectedItems && !selectedItems.length && dataList && !dataList.length && (
				<AddNewItem onClick={() => setFormVisible(true)}>+ ADD NEW {singular(dataTypeText).toUpperCase()}</AddNewItem>
			)}

			{formVisible && (
				<Fragment> 
					{children}
					{editFormItem ? (
						<SaveItemButtonPrimary icon="edit" type="primary" onClick={editSelected}>
						{saveButtonText}
					</SaveItemButtonPrimary>
					) :
					primary ? (
						<Fragment>
							<Divider />
							<SaveItemButtonPrimary icon="save" type="primary" onClick={addNewItem}>
								{saveButtonText}
							</SaveItemButtonPrimary>
						</Fragment>
					) : (
						<SaveItemButtonPrimary icon="save" type="primary" onClick={addNewItem}>
							{saveButtonText}
						</SaveItemButtonPrimary>
					)}
				</Fragment>
			)}
		</Fragment>
	)
}
export default DynamicForm
